import { theme } from '@styles';
import { animated } from 'react-spring';
import styled, { css } from 'styled-components';

import { Icon } from '../Icon';

export const DURATION = 350;
export const FLIP_DURATION = 800;

export const getCardHeight = ({ dynamicWidth }) => {
  if (dynamicWidth < 1300 && dynamicWidth >= 780) {
    return '530px';
  }

  if (dynamicWidth < 290) {
    return '520px';
  }

  return '360px';
};

export const CardContainer2 = styled(animated.div)`
  ${({ dynamicWidth, zIndex }) => css`
    position: absolute;
    ${zIndex && `z-index: ${zIndex};`}
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${getCardHeight({ dynamicWidth })};
    user-select: none;
    overflow: hidden;
    touch-action: none;
    border: 1px solid #4a4a4a;
  `}
`;

export const FrameContainer = styled.div`
  ${({ dynamicWidth }) => css`
    position: relative;
    width: 100%;
    height: ${getCardHeight({ dynamicWidth })};
    min-width: 100%;
    z-index: 1;
  `}
`;

export const StyledIcon = styled(Icon)`
  ${({ disabled, right }) => css`
    ${right && 'transform: rotate(180deg);'}
    ${disabled && 'opacity: 0.6;'}
  `}
`;

export const CardContainer = styled.div`
  ${({ dynamicWidth, isAnimatingFlip, theme: { colors } }) => css`
    perspective: 75rem;
    position: relative;
    height: ${getCardHeight({ dynamicWidth })};
    ${isAnimatingFlip && `background-color: ${colors.background};`}
    width: 100%;
    cursor: pointer;
  `}
`;

const CardSide = styled.div`
  ${({ theme: { colors } }) => css`
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.25);
    color: black;
    position: absolute;
    border: 1px solid ${colors.whiteLine[100]};
    top: 0;
    left: 0;
    backface-visibility: hidden;
    overflow: hidden;
    transition: transform ${FLIP_DURATION / 1000}s ease;
  `}
`;

export const Front = styled(CardSide)`
  width: 100%;
  transform: ${(props) =>
    props.rotateFront ? 'rotateY(-180deg)' : 'rotateY(0deg)'};
`;

export const Back = styled(CardSide)`
  width: 100%;
  transform: ${(props) =>
    props.rotateFront ? 'rotateY(0deg)' : 'rotateY(180deg)'};
`;

export const styles = {
  cardDefinition: {
    color: theme.colors.white[100],
    display: 'inline',
    justifyContent: 'center',
    lineHeight: '22px',
    style: {
      whiteSpace: 'break-spaces',
    },
  },
};
